import * as tslib_1 from "tslib";
import GroupListNode from './GroupListNode';
import datapoints from '../datapoints';
import toggleIsShowingAllGroups from '../mutators/toggleIsShowingAllGroups';
import { getLeftNavGroupsStore } from '../store/store';
import { MAX_GROUP_NODES_WHEN_COLLAPSED } from '../utils/constants';
import { observer } from 'mobx-react';
import { AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import { logMountingPerformance, logUsage } from 'owa-analytics';
import { getGroupsStore } from 'owa-groups-shared-store';
import strings from 'owa-strings/owa-groups-strings';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import * as React from 'react';
var groupsStore = getGroupsStore();
var leftNavGroupsStore = getLeftNavGroupsStore();
/**
 * Group list that renders a root node and all groups supplied to it and their children.
 */
var GroupList = /** @class */ (function (_super) {
    tslib_1.__extends(GroupList, _super);
    function GroupList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRootNodeChevronClicked = function (evt) {
            evt.stopPropagation();
            _this.props.toggleGroupTreeExpansion();
        };
        _this.onRootContextMenu = function (evt) {
            var onRootNodeContextMenuOpened = _this.props.onRootNodeContextMenuOpened;
            if (onRootNodeContextMenuOpened) {
                evt.stopPropagation();
                evt.preventDefault();
                onRootNodeContextMenuOpened(evt);
            }
        };
        _this.noContextMenu = function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
        };
        _this.onCollapseExpandeNodeClick = function (evt) {
            evt.stopPropagation();
            logUsage(datapoints.ToggleShouldShowAllGroups.datapoint.name, datapoints.ToggleShouldShowAllGroups.datapoint.customData(leftNavGroupsStore.shouldShowAllGroups, leftNavGroupsStore.myOrgGroups.length));
            toggleIsShowingAllGroups();
        };
        return _this;
    }
    GroupList.prototype.render = function () {
        var groupIds = leftNavGroupsStore.myOrgGroups;
        var ariaProps = {
            role: AriaRoles.tree,
        };
        var isGroupsTreeCollapsed = this.props.isGroupsTreeCollapsed();
        return (React.createElement("div", tslib_1.__assign({ style: this.props.style, className: this.props.className }, generateDomPropertiesForAria(ariaProps)),
            this.renderGroupRoot(isGroupsTreeCollapsed),
            this.renderChildren(groupIds, isGroupsTreeCollapsed),
            leftNavGroupsStore.withContextMenuGroup &&
                (leftNavGroupsStore.withContextMenuGroup.isRootNode
                    ? this.props.renderRootNodeContextMenu &&
                        this.props.renderRootNodeContextMenu(leftNavGroupsStore.withContextMenuGroup)
                    : this.props.renderChildNodeContextMenu &&
                        this.props.renderChildNodeContextMenu(leftNavGroupsStore.withContextMenuGroup)),
            groupIds.length > MAX_GROUP_NODES_WHEN_COLLAPSED &&
                this.renderCollapseExpandNode(isGroupsTreeCollapsed)));
    };
    GroupList.prototype.renderNode = function (group) {
        return (React.createElement(GroupListNode, { selectGroup: this.props.selectGroup, isSelected: this.props.isSelected, renderRightCharm: this.props.renderRightCharm, renderRightCharmHover: this.props.renderRightCharmHover, displayName: group.DisplayName, groupId: group.SmtpAddress, key: group.SmtpAddress, onContextMenu: this.props.onChildNodeContextMenuOpened, customData: this.props.customData }));
    };
    GroupList.prototype.renderGroupRoot = function (isGroupsTreeCollapsed) {
        var chevronProps = {
            isExpanded: !isGroupsTreeCollapsed,
            onClick: this.onRootNodeChevronClicked,
        };
        return (React.createElement(TreeNode, { chevronProps: chevronProps, depth: 0, displayName: strings.Groups, isRootNode: true, key: 'Groups_root', onClick: chevronProps.onClick, onContextMenu: this.onRootContextMenu, renderRightCharm: this.props.renderRootNodeRightCharm, renderRightCharmHover: this.props.renderRootNodeRightCharmHover }));
    };
    GroupList.prototype.renderChildren = function (myOrgGroups, isGroupsTreeCollapsed) {
        var _this = this;
        var renderedNodes = [];
        if (isGroupsTreeCollapsed) {
            return renderedNodes;
        }
        /*
            We either show the top 5 Groups in Prankie order or all Groups sorted by DisplayName
        */
        if (leftNavGroupsStore.shouldShowAllGroups) {
            var unsortedGroups_1 = [];
            myOrgGroups.forEach(function (groupId) {
                var group = groupsStore.groups.get(groupId);
                unsortedGroups_1.push(group);
            });
            unsortedGroups_1
                .sort(function (group1, group2) {
                return group1.basicInformation.DisplayName.localeCompare(group2.basicInformation.DisplayName);
            })
                .forEach(function (group) {
                renderedNodes.push(_this.renderNode(group.basicInformation));
            });
        }
        else {
            myOrgGroups.slice(0, MAX_GROUP_NODES_WHEN_COLLAPSED).forEach(function (groupId) {
                var group = groupsStore.groups.get(groupId);
                renderedNodes.push(_this.renderNode(group.basicInformation));
            });
        }
        return renderedNodes;
    };
    GroupList.prototype.renderCollapseExpandNode = function (isGroupsTreeCollapsed) {
        if (isGroupsTreeCollapsed) {
            return null;
        }
        var nodeDisplayName = leftNavGroupsStore.shouldShowAllGroups
            ? strings.groupsLeftNav_ShowLessButton
            : strings.groupsLeftNav_ShowMoreButton;
        return (React.createElement(TreeNode, { displayName: nodeDisplayName, isCustomActionNode: true, isRootNode: false, key: 'groupsCollapseExpandNode', onClick: this.onCollapseExpandeNodeClick, onContextMenu: this.noContextMenu }));
    };
    GroupList = tslib_1.__decorate([
        observer,
        logMountingPerformance('GroupList')
    ], GroupList);
    return GroupList;
}(React.Component));
export default GroupList;
//# sourceMappingURL=GroupList.js.map